import * as Highcharts from 'highcharts';

export const optionsChartObservadoDesvioClimatologia = (
	isPercentage: boolean
): Highcharts.Options => ({
	navigator: {
		enabled: false,
	},
	scrollbar: {
		enabled: false,
	},
	exporting: {
		enabled: false,
		buttons: {
			contextButton: {
				enabled: false,
			},
		},
	},
	rangeSelector: {
		enabled: false,
	},
	chart: {
		type: 'column',
		backgroundColor: 'transparent',
		zooming: {
			type: undefined,
			mouseWheel: {
				enabled: false,
			},
			pinchType: undefined,
			resetButton: {
				theme: {
					style: {
						display: 'none',
					},
				},
			},
		},
	},
	credits: {
		enabled: false,
	},
	xAxis: {
		categories: [],
	},
	yAxis: [
		{
			title: {
				text: 'Precipitação (mm)',
				style: {
					color: 'rgb(44, 175, 254)',
				},
			},
			labels: {
				format: '{value}',
				style: {
					color: 'rgb(44, 175, 254)',
				},
			},
			opposite: false,
		},
		{
			title: {
				text: `Desvio ${isPercentage ? '(%)' : '(mm)'}`,
				style: {
					color: 'rgb(84, 79, 197)',
				},
			},
			labels: {
				format: '{value}',
				style: {
					color: 'rgb(84, 79, 197)',
				},
			},
			opposite: true,
		},
	],
	tooltip: {
		shared: true,
		split: false,
		followPointer: true,
		useHTML: true,
	},
	plotOptions: {
		column: {
			borderWidth: 0,
		},
	},
	legend: {
		align: 'left',
		verticalAlign: 'top',
		enabled: true,
	},
	colors: ['#2CAFFE', '#00E272', '#544FC5'],
	series: [],
});
